import auctionVendorRepository from '@/repositories/auctionVendor';
import itemRepository from '@/repositories/item';
import jcPackage from '@/repositories/jcPackage';
import session from '@/repositories/session';
import transportVendorRepository from '@/repositories/transportVendor';
import yardVendorRepository from '@/repositories/yardVendor';
import { ActionTree } from 'vuex';

const actions: ActionTree<any, any> = {
  async checkAuth({ commit }) {
    const user = await session.getCurrentUser();
    return new Promise((resolve, reject) => {
      if (!user) {
        return resolve('');
      }
      //START QuocNV 20230519 update domain login rikuso 
      // const validDomains = ['jpctrade.com', 'japan-carrier.com'];
      const validDomains = process.env.VUE_APP_VALID_DOMAINS.split(',');
      if (validDomains.some((s:any) => user.email && user.email.indexOf(s) > -1) || user.email == 'backoffice@jpctrade.com') {
        commit('setUser', user);
        return resolve(user);
      }
      reject(`Invalid domain user (use ${validDomains.join(' or ')})`);
      //END QuocNV 20230519 update domain login rikuso 
    });
  },
  async getCustomerInf({ commit }, token: string) {
    await jcPackage.getListCustomerInf(token).then((rs) => {
      if (rs) {
        commit('setCustomerInf', rs);
      }
    });
  },
  async loadAssets({ commit }) {
    const token: any = await jcPackage.getTokenAccessJPC();
    commit('setTokenJPC', token);

    setTimeout(async() => {
      let customerInf = await jcPackage.getListCustomerInf(token.access_token)
      commit('setCustomerInf', customerInf);
    }, 1);
    
    const autionsVendor = await auctionVendorRepository.fetchAuctionVendorFromJC();
    commit('setAuctionVendors', autionsVendor);
 
    const yardVendor = await yardVendorRepository.fetchYardVendorFromJC();
    commit('setYardVendors', yardVendor);

    const handlingCompany = await yardVendorRepository.handlingCompanyFromJC();
    commit('setHandlingCompany', handlingCompany);

    const assets = await Promise.all([
      transportVendorRepository.fetchTransportVendorsFromJC(),
      itemRepository.sync(autionsVendor),
    ]);
    commit('setTransporVendors', assets[0]);
    // await itemRepository.updateImageFireBase();
  },
  async fetchOrdersAndBookingItems({ commit }) {
    commit(
      'setOrdersAndBookingItems',
      await itemRepository.getOrdersAndBookingItems((items) => {
        commit('setOrdersAndBookingItems', items);
      })
    );
  },
  async fetchBookedItems({ commit }) {
    commit(
      'setBookedItems',
      await itemRepository.getBookedItems((items) => {
        commit('setBookedItems', items);
      })
    );
  },
  async fetchBookedItemsMore({ commit }) {
    commit(
      'setBookedItemsMore',
      await itemRepository.getBookedItemsMore((items) => {
        commit('setBookedItemsMore', items);
      })
    );
  },
  saveItem(_, item) {
    return itemRepository.save(item);
  },
  createNewTransport(_, item) {
    return itemRepository.createNewTransport(item);
  },
  getItemByMatterNo(_, data) {
    return itemRepository.bookedRevert(data);
  },
  getNewItemByMatterNo(_, data) {
    return itemRepository.bookedRevert1(data);
  },
  updateVinNoInFireBase(_, data) {
    return itemRepository.updateVinNoFirebase(data);
  },
  async getTransportCosts(_, params) {
    const actualCosts = await transportVendorRepository.getActualCostsFromJC(
      params.auctionSiteId,
      params.satelliteId,
      params.area,
      params.fromYardPlace,
      params.placeYardType
    );
    const costs = await transportVendorRepository.getCostsFromJC(
      params.auctionSiteId,
      params.satelliteId,
      params.area,
      params.customerId ,
      params.fromYardPlace,
      params.placeYardType
    );
    return actualCosts.map((cost: any) => ({
      id: cost.TransportCostID.value,
      actualCost: +cost.Actual_Cost.value,
      cost: costs.length > 0 ? costs[0].base : 0,
      costA: costs.length > 0 ? costs[0].base + costs[0].a : 0,
      costB: costs.length > 0 ? costs[0].base + costs[0].b : 0,
      costC: costs.length > 0 ? costs[0].base + costs[0].c : 0,
      costD: costs.length > 0 ? costs[0].base + costs[0].d : 0,
      costE: costs.length > 0 ? costs[0].base + costs[0].e : 0,
      vendorId: cost.TransporterID.value,
      vendorName: (cost.TransporterNameE.value != null) ? cost.TransporterNameE.value : '',
    }));
  },
};

export default actions;
